import styled from 'styled-components';

export const Title = styled.div`
  font-size: 20px;
  color: ${(props) => (props.theme.theme === 'dark' ? '#ddd' : '#262b31')};
  font-weight: bold;
  line-height: 1.3;
  overflow-wrap: break-word;
  &.with-info {
    margin: 0 0 8px;
  }
  &.center{
    text-align: center;
  }
`;

export const Content = styled.div`
  white-space: normal;
  display: flex;
  flex-direction: column;
  min-height: 60px;
  /* align-items: center; */
  justify-content: center;

  &.danger,
  &.error,
  &.warning {
    background: url('/images/exclamation.svg') no-repeat 0 50%;
    background-size: 50px;
    padding-left: 65px;
    /* padding-top: 12px; */
  }
`;

export const WarningText = styled.div`
  font-size: 15px;
  /* color: #000; */
  /* margin-bottom: 25px; */
  line-height: 1.2;
`;
